import type { BranchVersion } from "~/entities/branch-version/types";
import axiosInstance from "~/shared/api/axios-instance";
import { toValidUntil } from "../lib/to-valid-until";

interface BranchVersionResponse {
  id: number;
  branch_uid: string;
  name: string;
  description: string;
  created_at: number;
  valid_from?: string;
  valid_until?: string;
  is_active: boolean;
  has_been_active?: boolean;
}

export const createBranchVersion = async (params: {
  branchUid: string;
  name: string;
  description: string;
  validFrom: string;
  validTo: string;
  baseBranchVersionId?: number;
  setCameraTypeDefault: boolean;
  /** PO QA 4차 ai: BE 가 create 트랜잭션에서 활성화까지 처리 (단일 호출, race 제거) */
  isActive?: boolean;
}): Promise<BranchVersion> => {
  const { data } = await axiosInstance.post<BranchVersionResponse>(
    `branches/${params.branchUid}/versions/`,
    {
      name: params.name,
      description: params.description,
      valid_from: params.validFrom || null,
      valid_until: toValidUntil(params.validTo),
      base_version_id: params.baseBranchVersionId ?? null,
      set_camera_type_default: params.setCameraTypeDefault,
      is_active: params.isActive ?? false,
    },
  );
  return {
    id: data.id,
    branchUid: data.branch_uid,
    name: data.name,
    description: data.description,
    createdAt: data.created_at,
    validFrom: data.valid_from,
    validTo: data.valid_until,
    isActive: data.is_active,
    hasBeenActive: data.has_been_active ?? false,
  };
};
